import React, { Component } from 'react';
import AdminNavigationBar from './AdminNavigationBar';
import { Link } from 'react-router-dom';

class UserCreator extends Component {
    constructor() {
        super();
        this.state = { username: '', password: '' };
        this.onUsernameChange = this.onUsernameChange.bind(this);
        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.createUser = this.createUser.bind(this);
    }

    componentDidMount() {
        fetch(`/api/users`, { credentials: 'same-origin' }).then(response => {
            if (response.status !== 200) {
                location.href = '#/login';
            }
        });
    }

    render() {
        return (
            <div>
                <AdminNavigationBar />
                <div className="container col-md-6">
                    <h1>Nowy użytkownik</h1>
                    { this.state.created ? <div className="inline-block alert alert-info">Utworzono użytkownika.</div> : ''}
                    { this.state.error ? <div className="inline-block alert alert-danger">{this.state.error}</div> : '' }
                    <form>
                        <div className="row">
                            <div className="col col-md-9">
                                <div className="form-group col-md-9">
                                    <label>Login:</label>
                                    <input
                                    type="text"
                                    className={"form-control " + this.validationClass('username')}
                                    value={this.state.username}
                                    onChange={this.onUsernameChange()}></input>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col col-md-9">
                                <div className="form-group col-md-9">
                                    <label>Hasło:</label>
                                    <input
                                    type="text"
                                    className={"form-control " + this.validationClass('password')}
                                    value={this.state.password}
                                    onChange={this.onPasswordChange()}></input>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col col-md-6">
                                <div className="form-group col-md-6">
                                <button className="btn btn-primary" onClick={this.createUser}>Utwórz</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    validationClass(fieldName) {
        if (this.state.invalidFields && this.state.invalidFields.includes(fieldName)) {
          return 'is-invalid';
        } else {
          return '';
        }
      }

    onUsernameChange() {
      return (evt) => {
        this.setState({ username: evt.target.value });
      };
    }

    onPasswordChange() {
      return (evt) => {
        this.setState({ password: evt.target.value });
      };
    }

    createUser() {
      fetch(
        `/api/users`,
        {
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            username: this.state.username,
            password: this.state.password
          })
        }).then(response => {
          if (response.status === 200) {
            response.text().then(data => location.href = '#/users');
          } else {
            response.json().then(data => this.setState({
              error: 'Nie podano wszystkich danych!',
              invalidFields: data.errors
            }));
          }
        });
    }
}

export default UserCreator;



// WEBPACK FOOTER //
// ./components/UserCreator.js